export const USPS_MAIL_TO_RECIPIENT_LOADING_STATES = {
    USPS_MAIL_FEE_LOADING: "USPS_MAIL_FEE_LOADING",
    USPS_MAIL_FEE_READY: "USPS_MAIL_FEE_READY",
}